<div class="flex flex-wrap">
    <div *ngFor="let item of mediaList; let i = index" (click)="openLightbox(i)"
        class="mb-9 mr-8 w-52 sm:w-full sm:mb-6 sm:mr-0 smmd:w-36 md:w-44 reveal">
        <img [src]="item.path" alt="" class="w-full cursor-pointer">
        <div *ngIf="item.description" class="mt-4 text-gray-grayText text-left text-xs sm:text-center">
            <span>{{
                item.description[currentLanguage] }}</span>
        </div>
    </div>
</div>